import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Divider,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  ShoppingCart,
  AccountCircle,
  Settings as SettingsIcon,
  ExitToApp,
  Person,
  Help,
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import logo0 from '../assets/logo0.png';

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#000000',
  boxShadow: 'none',
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
});

const LogoImage = styled('img')({
  height: '20px',
  filter: 'brightness(0) invert(1)', // Makes the logo white
  cursor: 'pointer'
});

const HeaderIconButton = styled(IconButton)({
  color: '#ffffff',
  marginLeft: '16px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)'
  }
});

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#108a00',
    color: 'white',
  },
}));

const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
  }
}));

const Nav1 = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledAppBar position="static">
      <Toolbar>
        <Container maxWidth="lg" sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/">
              <LogoImage src={logo0} alt="Logo" onClick={() => navigate('/dashboard')} />
            </Link>
            <Link 
              to="/support" 
              style={{ 
                textDecoration: 'none', 
                color: '#ffffff',
                marginLeft: '24px'
              }}
            >
              Support
            </Link>
            <Link 
              to="/remotesupport" 
              style={{ 
                textDecoration: 'none', 
                color: '#ffffff',
                marginLeft: '24px'
              }}
            >
              Remote Support
            </Link>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <HeaderIconButton component={Link} to="/cart">
              <StyledBadge badgeContent={2}>
                <ShoppingCart />
              </StyledBadge>
            </HeaderIconButton>

            <HeaderIconButton
              onClick={handleProfileClick}
              aria-controls={open ? 'profile-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <AccountCircle />
            </HeaderIconButton>
          </Box>
        </Container>
      </Toolbar>

      {/* Profile Dropdown Menu */}
      <StyledMenu
        id="profile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem component={Link} to="/profile">
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          <ListItemText>Profile</ListItemText>
        </MenuItem>
        
        <MenuItem component={Link} to="/settings">
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>

        <MenuItem component={Link} to="/help">
          <ListItemIcon>
            <Help fontSize="small" />
          </ListItemIcon>
          <ListItemText>Help Center</ListItemText>
        </MenuItem>

        <Divider />
        
        <MenuItem onClick={() => { /* Add logout logic */ }}>
          <ListItemIcon>
            <ExitToApp fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </StyledMenu>
    </StyledAppBar>
  );
};

export default Nav1; 